import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { ApiGet } from "../../../service/ApiService";

const ProductModalForm = ({ show, onHide, invoiceId, product, onSave }) => {
    // Local state for available warehouses.
    const [warehouses, setWarehouses] = useState([]);

    // Initialize formData with product values if editing, or defaults if adding new.
    const [formData, setFormData] = useState({
        name: "",
        code: "",
        quantity: 0,
        price: 0,
        measuringUnitName: "buc",
        currency: "RON",
        taxName: "Normala",
        taxPercentage: 19,
        saveToDb: false,
        service: false,
        warehouseName: "",
    });

    useEffect(() => {
        // Load warehouses from the API.
        ApiGet(
            "/api/smartbill/warehouses",
            (response) => {
                setWarehouses(response || []);
                if (response && response.length > 0) {
                    // If adding a new product, set default warehouseName to the first value.
                    if (!product) {
                        setFormData((prev) => ({
                            ...prev,
                            warehouseName: response[0].warehouseName,
                        }));
                    }
                }
            },
            (error) => {
                console.error("Eroare la preluarea depozitelor.", error);
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (product) {
            setFormData({ ...product });
        } else {
            // Set default values for the add case.
            setFormData({
                name: "",
                code: "",
                quantity: 0,
                price: 0,
                measuringUnitName: "buc",
                currency: "RON",
                taxName: "Normala",
                taxPercentage: 19,
                saveToDb: false,
                service: false,
                warehouseName: warehouses.length > 0 ? warehouses[0].warehouseName : "",
            });
        }
    }, [product, show, warehouses]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Include invoiceId reference when saving.
        const payload = { ...formData, invoiceId };
        onSave(payload);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{product ? "Editează Produs" : "Adaugă Produs"}</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="modalProductName">
                                <Form.Label>Denumire produs</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="modalProductCode">
                                <Form.Label>Cod produs</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="code"
                                    value={formData.code}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="modalQuantity">
                                <Form.Label>Cantitate</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="quantity"
                                    value={formData.quantity}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="modalPrice">
                                <Form.Label>Preț</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    name="price"
                                    value={formData.price}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="modalMeasuringUnit">
                                <Form.Label>UM</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="measuringUnitName"
                                    value={formData.measuringUnitName}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="modalCurrency">
                                <Form.Label>Monedă</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="currency"
                                    value={formData.currency}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="modalTaxName">
                                <Form.Label>Taxă</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="taxName"
                                    value={formData.taxName}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="modalTaxPercentage">
                                <Form.Label>Procent TVA</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="taxPercentage"
                                    value={formData.taxPercentage}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group controlId="modalWarehouse">
                                <Form.Label>Depozit</Form.Label>
                                <Form.Select
                                    name="warehouseName"
                                    value={formData.warehouseName}
                                    onChange={handleChange}
                                >
                                    {warehouses.map((wh) => (
                                        <option key={wh.id} value={wh.warehouseName}>
                                            {wh.warehouseName}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Check
                                type="checkbox"
                                label="Salvează în DB"
                                name="saveToDb"
                                checked={formData.saveToDb}
                                onChange={handleChange}
                            />
                            <Form.Check
                                type="checkbox"
                                label="Serviciu"
                                name="service"
                                checked={formData.service}
                                onChange={handleChange}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        Anulează
                    </Button>
                    <Button variant="primary" type="submit">
                        Salvează
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ProductModalForm;
